<template>
  <div class="uep_player_v2 custom component" :class="{ 'comments-list': comments }">
    <uep-player-component
      v-if="!hasError && !hasErrorAccess"
      :class="{ 'vjs-audio-options-poster': isAudioOptions }"
      ref="videoPlayer"
      :options="options"
      :videoId="videoId"
      :hasVideoStats="tmpQ.videoStats"
    >
    </uep-player-component>

    <UepCommentsList
      v-if="comments && !hasError"
      v-model="commentsCookie"
      :class="{
        'comments-navigation-slides': commentsNavigationSlides,
        'comments-montage': commentsMontage,
        'comments-interactivity': commentsInteractivity,
      }"
    >
    </UepCommentsList>
    <error-component v-if="hasError" :title="title" :msg="msg" :code="code" :formEmail="formEmail"></error-component>
    <error-access-component v-if="hasErrorAccess" :title="title"></error-access-component>
    <div class="debug" v-if="optionsDebug.debug && hasError">
      <span v-html="optionsDebug.debugText"></span>
    </div>
    <!--<div id="fixed-navigation" class="fixed-navigation-class">-->
    <!--</div>-->
  </div>
</template>
<script>
  //video = docShadow.querySelector('video');
  import {HTTP, HTTP_CHECK, HTTP_SECURE} from '../core/http/http-common';
  import Routing from '../core/router/router';
  import UepCommentsList from '../components/workspaceComponents/UepCommentsList.vue';
  import UepPlayerComponent from '../components/UepPlayerComponent.vue';
  import globalOptions from '../core/info/info';
  import helper from '../mixins/helper';
  import mixins from '../mixins/mixins';
  import store from '../store/index_simple.js';
  import axios from 'axios';
  import {mapActions} from 'vuex';
  import en from '../i18n/en_US';
  import fr from '../i18n/fr_FR';
  export default {
    name: 'uep-player',
    mixins: [helper, mixins],
    components: {
      ErrorComponent: () => import("../components/ErrorComponent.vue"),
      ErrorAccessComponent: () => import("../components/ErrorAccessComponent.vue"),
      UepPlayerComponent,
      UepCommentsList

    },
    props: ['url', 'query', 'menu', 'color', 'standalone', "videoFileName"],
    i18n: {
      messages: {
        en: en,
        fr: fr,
      },
    },
    data() {
      return {
        player: null,
        formEmail: true,
        options: {
          initialized: true,
          currentTech: '',
          streams: {
            rtmp: '',
            hls: '',
          },
        },
        videoId:null,
        isAudioOptions: false,
        comments: false,
        commentsNavigationSlides: false,
        commentsInteractivity: false,
        commentsMontage: false,
        hasError: false,
        hasErrorAccess: false,
        optionsDebug: {
          debug: false,
          debugText: '',
        },
        msg: '',
        title: '',
        code: '',
        tmpQ: {}
      };
    },
    beforeCreate() {
      this.$store = store;
    },
    mounted() {
      this.setCheckToken()
      if (!this.player && !this.$route.query.id_member && !this.$route.query.token_user ) {
           this.createPlayer()
      }
      var self = this;
      eventHub.$on('changeLanguage', function (lang) {
        try {
          self.$root.$i18n.locale = lang;
          localStorage.setItem('lang-player', lang);
        } catch (e) {
        }
      });
      document.onkeydown = function (evt) {
        evt = evt || window.event;
        var isEscape = false;
        if ('key' in evt) {
          isEscape = evt.key === 'Escape' || evt.key === 'Esc';
        } else {
          isEscape = evt.keyCode === 27;
        }
        if (isEscape) {
          var unfocusBtnEl = docShadow.getElementById('unfocus-btn');
          if (unfocusBtnEl && window.getComputedStyle(unfocusBtnEl).display === 'block') {
            unfocusBtnEl.click();
          }
        }
      };
    },
    methods: {
      /**
       * Actions from Vuex Store
       */
      ...mapActions(['setVideoOptionsComments']),
      initLang: function (language) {
        var self = this;
        try {
          self.$root.$i18n.locale = language;
          localStorage.setItem('lang-player', language);
        } catch (e) {
        }
      },
        setCheckToken(){
          let self=this;
            let data={user_id: parseInt(this.$route.query.id_member), token: this.$route.query.token_user}
            if(this.$route.query.id_member && this.$route.query.token_user && process.env.API_CHECK_TOKEN){
              new Promise((resolve, reject)=>{
                  const params = new URLSearchParams();
                  params.append('user_id', data.user_id);
                  params.append('token', data.token);
                  HTTP_CHECK(data).post(
                      "/checkToken"
                   ,params
                  ).then(resp=>{
                          resolve(resp)
                          if(resp.data.IsAuthorized){
                              self.createPlayer()
                          }else{
                              self.hasErrorAccess = true;
                          }
                      }

                  ).catch(err=>{
                      console.log('err-------',err)
                      self.hasErrorAccess = true;
                      reject(err)
                  })
              })
          }else if (process.env.API_CHECK_TOKEN &&( (this.$route.query.id_member && !this.$route.query.token_user ) || (!this.$route.query.id_member && this.$route.query.token_user ))){
              self.hasErrorAccess = true;
            }

        },
       async generateToken(src){
           await HTTP_SECURE.get().then( result=>{
                        if(result.status===200 || result.data.status===200){
                            src=src+"?hdnts="+result.data.token;
                        }
                    }
                ).catch(err=>{
                    console.log('err---',err)
                })
            console.log("generateToken : ",src);
            return src

        },
        createPlayer(){
          this.initialize()
        },
      readyPlayer: function (options) {
        if (this.tmpQ && this.tmpQ.x) {
          options.currentTime(this.tmpQ.x);
        }
        this.$emit('readyPlayer', options);
        setTimeout(() => {
          const iframeVideoJs = docShadow.querySelector('.vjs-youtube iframe.vjs-tech');
          if (iframeVideoJs) {
            iframeVideoJs.style = '';
          }
        }, 100);
      },
      infoDetails: function (options) {
        this.$emit('infoDetails', options);
      },
      partageButton: function (options) {
        this.$emit('partageButton', options);
      },
      nextVideo: function (currentVideo) {
        try {
          var url = this.options.playListOptions.sources[currentVideo].sources;
          /*todo playlist*/
          this.indexVideo = currentVideo;
          this.initialize(url);
        } catch (e) {
          console.log('nextVideo');
          console.log(e);
        }
      },
      mobileCheck() {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
      },
      getOptions(options, plugin, skin, menu, autoplay, loop, controlBar, crypttext, self, langue) {
        options.crypttext = crypttext;
        if (this.indexVideo && options.playListOptions) {
          options.playListOptions.indexVideo = this.indexVideo;
          import('videojs-playlist/dist/videojs-playlist');
          import('videojs-playlist-uep/dist/videojs-playlist-uep.cjs');
        }
        if (options.playerOptions && options.playerOptions.techOrder && !options.playerOptions.techOrder.includes('html5') && !options.playerOptions.techOrder.includes('flash')) {
          //this.getScript('Youtube.min.js');
          import('videojs-externals/dist/videojs-externals.js');
        }



        options.playerOptions.exitFullscreenOnEnd = false;
        options.playerOptions.preload = "none";
        options.hlsQualityOptions = {defaultBitrate: -1, high_bitrate: 4000, showMbrList: true};

        options.hotKeyOptions = menu === 'default' ? false : self.options.hotKeyOptions;
        options.playerOptions.language = langue;

        options.playerOptions.playsinline = true;
        options.plugin = plugin;
        options.menu = menu;
        options.debug = self.tmpQ.debug == 1 ? true : false;
        options.playerOptions.autoplay = options.panoramaOptions ? false :( autoplay
          ? self.tmpQ.a == 1
            ? true
            : false
          : options.playerOptions.autoplay);
        options.playerOptions.muted = !this.mobileCheck() && options.playerOptions.autoplay ? true : false;
        options.playerOptions.controlBarOptions = controlBar
          ? self.tmpQ.sc == 1
            ? true
            : false
          : options.playerOptions.controlBarOptions;
        options.playerOptions.loop = loop
          ? self.tmpQ.loop == 1
            ? true
            : false
          : options.playerOptions.loop;
        /* initialize the techOrder attribute */
        options.techOrder = options.playerOptions.techOrder;
        options.navigation = options.plugin === 'navigation';
        // this.player.trigger('error');
        /* add class to player tag - vjs-tech-* */
        this.addTechTagToPlayer(this.$refs.videoPlayer.$el, options.playerOptions);

        if (options.isAudioOptions === undefined || !options.isAudioOptions) {
          this.isAudioOptions = false;
        } else {
          this.isAudioOptions = true;
        }
        options.currentSkin = [];
        if (plugin === 'montage') {
          options.currentSkin.push('skin-' + 'm1');
          skin = 'm1';
        } else if (plugin === 'interactivity') {
          if (!skin) {
            skin = 'i1';
          }
          var res = skin.split(' ');
          for (var x in res) {
            options.currentSkin.push('skin-' + res[x]);
          }
        } else {
          var res = skin.split(' ');
          for (var x in res) {
            options.currentSkin.push('skin-' + res[x]);
          }
        }
        if (skin === '18' && !videojs.browser.TOUCH_ENABLED) {
          options.playerOptions.controlBar = {
            volumePanel: {
              inline: false,
              vertical: true,
            },
          };
        }
        if (skin === 'dark') {
          options.playerOptions.playbackRates = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2].reverse();
        }
        if (options.sendMailOptions) {
          options.sendMailOptions = {
            HTTP: HTTP,
            URL: Routing.generate('api_media_send_video_by_mail_from_player'),
            cryptedParam: crypttext,
            client: options.client,
          };
        }
        if (plugin === 'montage') {
          options.montageOptions = true;
        }
        if (plugin === 'navigation') {
          var api_post_comment = {
            HTTP: HTTP,
            URL: Routing.generate('api_media_post_add_comments'),
            mediaId: options.playerOptions.mediaId,
            client: options.client,
          };
          var api_list_comment = {
            HTTP: HTTP,
            URL: Routing.generate('api_media_get_comment_media_by_video', {
              id: options.playerOptions.videoId,
            }),
            client: options.client,
          };
          var api_post_survey = {
            HTTP: HTTP,
            URL: Routing.generate('api_survey_add_response_to_survey_for_video'),
            videoId: options.playerOptions.videoId,
            client: options.client,
          };
          //waiting the api
          var api_list_survey = {
            HTTP: HTTP,
            URL: Routing.generate('api_media_get_survey_for_video', {
              id: options.playerOptions.videoId,
            }),
            client: options.client,
          };
          var api_search = {
            HTTP: HTTP,
            URL: Routing.generate('api_media_get_interactivities'),
            client: options.client,
            videoId: options.playerOptions.videoId,
          };
          var api_search_post = {
            HTTP: HTTP,
            URL: Routing.generate('api_media_post_add_rich_media_responses'),
            client: options.client,
            videoId: options.playerOptions.videoId,
          };
          options.allOptions = {};
          options.allOptions.searchOptions = {};
          options.allOptions.searchOptions.api = {
            api_search: api_search,
            api_search_post: api_search_post,
          };
          options.allOptions.menuOptions = ['close'];
          if (
            (options.exportOptions && options.exportOptions.hasOwnProperty('url')) ||
            (options.shareOptions && options.shareOptions.hasOwnProperty('socials'))
          ) {
            options.allOptions.menuOptions.push('share');
          }
          if (options.files && options.files.length > 0) {
            options.allOptions.filesOptions = {};
            options.allOptions.filesOptions.files = options.files;
            options.allOptions.menuOptions.push('files');
          }
          if (options.sendMailOptions) {
            options.allOptions.sendMailOptions = options.sendMailOptions;
          }
          if (options.surveyOptions) {
            options.allOptions.menuOptions.push('survey');
            options.allOptions.surveyOptions = {};
            options.allOptions.surveyOptions.api = {
              api_list_survey: api_list_survey,
              api_post_survey: api_post_survey,
            };
          }
          if (options.commentsOptions) {
            options.allOptions.menuOptions.push('comments');
            options.allOptions.commentsOptions = {};
            options.allOptions.commentsOptions.noScroll = true;
            options.allOptions.commentsOptions.api = {
              api_list_comment: api_list_comment,
              api_post_comment: api_post_comment,
            };
          }

          if (options.searchOptions) {
            options.allOptions.menuOptions.push('search');
          }
          if (options.infoOptions && options.infoOptions.hasOwnProperty('title')) {
            options.allOptions.menuOptions.push('info');
          }

          options.allOptions.exportOptions = options.exportOptions;
          options.allOptions.infoOptions = options.infoOptions;
          options.allOptions.rmOptions = options.rmOptions;
          options.allOptions.shareOptions = options.shareOptions;
          if (
            options.rmOptions &&
            options.rmOptions.hasOwnProperty('chapters') &&
            options.rmOptions.chapters.length > 0
          ) {
            options.allOptions.menuOptions.push('richMedia');
          }

          if (options.allOptions.menuOptions.length == 1) {
            options.navigation = false;
          }
        }
        if (plugin === 'interactivity') {
          options.allOptions = {};
          options.allOptions.infoOptions = options.infoOptions;
          options.allOptions.menuOptions = ['info'];
          if (
            options.rmOptions &&
            options.rmOptions.hasOwnProperty('slides') &&
            options.rmOptions.slides.length > 0 &&
            options.currentSkin.indexOf('skin-i2') > 0
          ) {
            options.rmOptions.hideSliders = true;
          }
        }

        options.initialized = false;

        if (videojs.browser.TOUCH_ENABLED) {
          options.hotKeyOptions = false;
          options.playerOptions.playbackRates = null;
          options.playerOptions.controlBar = {
            volumeMenuButton: false,
            volumePanel: false,
          };
        }
        /* comment component */
        let currentUser = {};
        if (options.commentsOptionsUser) {
          /* get the curent user's informations */
          currentUser = {};
          /* activate the comment component when the user is connected and the comment options is enabled */
          /* set the plugin's style (for the comment component) */
          if (plugin === 'navigation' || plugin === 'simple') {
            if (options.interactivityOptions &&
              options.interactivityOptions.data &&
              options.interactivityOptions.data.slides.length > 0
            ) {
              this.commentsNavigationSlides = true;
            }
          } else if (plugin === 'interactivity' || plugin === 'fixedNavigation') {
            this.commentsInteractivity = true;
          } else if (plugin === 'montage') {
            this.commentsMontage = true;
          }
          /* save infos in the store */
          this.setVideoOptionsComments({
            videoId: options.playerOptions.videoId,
            mediaId: options.playerOptions.mediaId,
            user: currentUser,
            client: options.client,
          });
          this.comments = true;
          this.commentsCookie = true;

        }
        if (
          options.subscriptionOptions !== undefined &&
          options.subscriptionOptions.Fid !== undefined
        ) {

          if (options.subscriptionOptions.id !== undefined) {
            /* get the curent user's informations */
            currentUser = {
              id: options.subscriptionOptions.id,
              name:
                options.subscriptionOptions.firstName + ' ' + options.subscriptionOptions.lastName,
              email: options.subscriptionOptions ? options.subscriptionOptions.email : '',
            };
            /* activate the comment component when the user is connected and the comment options is enabled */
            /* set the plugin's style (for the comment component) */
            if (plugin === 'navigation' || plugin === 'simple') {
              if (options.interactivityOptions &&
                options.interactivityOptions.data &&
                options.interactivityOptions.data.slides.length > 0
              ) {
                this.commentsNavigationSlides = true;
              }
            } else if (plugin === 'interactivity' || plugin === 'fixedNavigation') {
              this.commentsInteractivity = true;
            } else if (plugin === 'montage') {
              this.commentsMontage = true;
            }
            /* save infos in the store */
            this.setVideoOptionsComments({
              videoId: options.playerOptions.videoId,
              mediaId: options.playerOptions.mediaId,
              user: currentUser,
              client: options.client,
            });
            this.comments = false;
            if (options.commentsOptions) {
              this.comments = true;
            }
          }
        }

        return options;
      },
     async initialize (url) {
        console.log("initialize");

        this.hasError = false;
        this.hasErrorAccess = false;
        var self = this;
        var tmpQ = this.query;
        tmpQ = typeof tmpQ == 'string' ? JSON.parse(tmpQ) : tmpQ;
        var items = location.search.substr(1).split("&");
        for (var index = 0; index < items.length; index++) {
          tmpQ[items[index].split("=")[0]] = items[index].split("=")[1];
        }
        if (tmpQ.color) {
          var resultC = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(tmpQ.color);
          tmpQ.color = resultC
            ? parseInt(resultC[1], 16) + ", " + parseInt(resultC[2], 16) + ", " + parseInt(resultC[3], 16)
            : tmpQ.color;
        }

        var crypttext = url !== undefined ? url : this.url;
        var videoFileName = videoFileName !== undefined ? videoFileName : this.videoFileName;
        var plugin =
          tmpQ !== undefined && tmpQ.plugin !== undefined ? tmpQ.plugin : 'simple';
        var token =
          tmpQ !== undefined && tmpQ.token !== undefined ? tmpQ.token : '';
        var skin =
          tmpQ !== undefined && tmpQ.skin !== undefined && tmpQ.skin !== "" ? '' + tmpQ.skin : 'dark';
        var menu =
          tmpQ !== undefined && tmpQ.menu !== undefined ? tmpQ.menu : 'default';
        var color =
          tmpQ !== undefined && tmpQ.color !== undefined ? tmpQ.color : '';
        var autoplay = !!(tmpQ !== undefined && tmpQ.a !== undefined);
        var loop = !!(tmpQ !== undefined && tmpQ.loop !== undefined);
        var controlBar = !!(tmpQ !== undefined && tmpQ.sc !== undefined);
        var standalone = this.standalone !== undefined ? (typeof this.standalone == 'string' ? JSON.parse(this.standalone) : this.standalone) : null;
        var panorama =
          tmpQ !== undefined && tmpQ.panorama !== undefined ? tmpQ.panorama : false;
         var videoStats =
             tmpQ !== undefined && tmpQ.videoStats !== undefined ? tmpQ.videoStats : false;
         console.log('videoStats-----------',videoStats)
        this.tmpQ = tmpQ;
        import ('videojs-rich-media/dist/videojs-rich-media.css');
        if (skin == 18) {
          import ('../assets/skin-18.css')
        } else {
          skin = 'dark';
           import ('../assets/output.css');
        }
        var options = {};
        var language =
          tmpQ !== undefined && tmpQ.lang !== undefined ? tmpQ.lang : '';
        try {
          docShadow.querySelector('#uep_player_component').style.backgroundImage = '';
          docShadow.querySelector('.background_play_list').style.backgroundImage = '';
          docShadow.querySelector('.background_play_list').style.height = '0%';
        } catch (e) {
        }
        if (color !== '') {
          document.body.style.setProperty('--main-color-15', color);
          document.body.style.setProperty('--main-color', color);
          document.body.style.setProperty('--dark-player-color', color);
        }
        if (standalone !== null) {
          delete standalone.data.__proto__;op
          standalone = Object.assign({}, globalOptions, standalone);
          options = standalone.data;
          options.panoramaOptions = panorama;

          if (!crypttext) {
            crypttext = standalone.dataVideo ? standalone.dataVideo.crypted : null;
          }
          console.log("options.infoOptions", options.infoOptions);
          language = language ? language : (options.infoOptions && options.infoOptions.current_lang ? options.infoOptions.current_lang : 'fr');
          let lan = language || 'fr';
          localStorage.setItem('lang-player', lan);
          options = self.getOptions(
            options,
            plugin,
            skin,
            menu,
            autoplay,
            loop,
            controlBar,
            crypttext,
            self,
            lan,
          );
          this.options = options;
        } else if (crypttext !== undefined && crypttext !== '') {
          var req = {query: this.tmpQ};
          if (token) {
            req.token = token;
          }
          HTTP.post(
            Routing.generate('api_media_post_player_info_and_links', {crypttext: crypttext}),
            req,
          ).then(
            function (response) {
              if (response.data.code === 200) {
                options = response.data.data;
                const id_video = options.playerOptions.videoId;
                options.panoramaOptions = panorama ? panorama : options.panoramaOptions;
                const langFo = localStorage.getItem('lang-fo');
                let lan =
                  language ||
                  langFo ||
                  (options.infoOptions && options.infoOptions.current_lang
                    ? options.infoOptions.current_lang
                    : 'fr');
                options = self.getOptions(
                  options,
                  plugin,
                  skin,
                  menu,
                  autoplay,
                  loop,
                  controlBar,
                  crypttext,
                  self,
                  lan,
                );
                self.initLang(lan);
                if (options.paramsOptions && options.paramsOptions.isBO === false)
                  self.getStatsData(options);
                options.debugText = 'init options';

                if (options.intranetOptions && options.playerOptions.srcVideo && (self.tmpQ && self.tmpQ.isTl == 1  )) {
                  options.debugText +=
                    '<br>has intranet ' +
                    options.intranetOptions +
                    '  ' +
                    options.playerOptions.srcVideo;

                  if (!options.playerOptions.dispoFO) {
                    /*CODE 3*/
                    self.hasError = true;
                    self.title = 'Code 3';
                    self.msg = self.$t('editor.error.video-not-found');
                    self.addErrorToPlayer({
                      client: options.client,
                      email: options.subscriptionOptions ? options.subscriptionOptions.email : '',
                      id_video,
                      code_error: 3,
                    });
                  } else {
                    axios.get(options.intranetOptions, {timeout: 30000}).then(
                      function (response) {
                        var data = response.data;
                        options.debugText += '<br>api zonnig ' + data;
                        if (data.res === 'noresultfound') {
                          //var server = data.slice(data.indexOf('=') + 1, data.indexOf('#'));
                          self.hasError = true;
                          /* var server = JSON.stringify(data.res).slice(0, data.indexOf('#'));

                          options.debugText += '<br>server ' + server;
                          options.playerOptions.sources.forEach(function(item) {
                            console.log(item)
                            item.src = server + options.playerOptions.srcVideo;
                            options.debugText += '<br>src ' + item.src;
                          });*/

                          /*CODE 2*/
                          self.title = 'Code 2';
                          self.msg = self.$t('editor.error.api-error-msg');
                          self.addErrorToPlayer({
                            client: options.client,
                            email: options.subscriptionOptions
                              ? options.subscriptionOptions.email
                              : '',
                            id_rmbox_player: data.box_id,
                            ip_client: data.ip_client,
                            options: data.error,
                            id_video,
                            code_error: 2,
                          });
                        } else {
                          self.options = options;
                          self.options.playerOptions.sources =
                            [
                              {
                                src: data.res + options.playerOptions.srcVideo,
                                type: 'video/mp4',
                              },
                            ] ;


                          eventHub.$on('playerError', function (event) {
                            /*CODE 4*/
                            self.hasErrorVideo = true;
                            self.formEmail = false;

                            self.title = 'Code 4';
                            self.msg = self.$t('editor.error.no-result-msg');
                            self.code = 4;
                            self.addErrorToPlayer({
                              client: options.client,
                              email: options.subscriptionOptions
                                ? options.subscriptionOptions.email
                                : '',
                              id_rmbox_player: data.box_id,
                              ip_client: data.ip_client,
                              options: data.error,
                              id_video,
                              code_error: 4,
                            });

                            options.debugText += '<br>noresultfound ';
                            console.log('options error');
                            self.hasError = true;
                            self.optionsDebug.debug = options.debug;
                            self.optionsDebug.debugText = options.debugText;
                          });
                        }
                      },
                      function (error) {
                        /*CODE 1*/
                        self.title = 'Code 1';
                        self.msg = self.$t('editor.error.api-zonning');
                        self.code = '1';
                        self.addErrorToPlayer({
                          client: options.client,
                          id_video,
                          id_rmbox_player: null,
                          code_error: 1,
                          email: options.subscriptionOptions ? options.subscriptionOptions.email : '',
                        });

                        options.debugText += '<br>api zonnig connexion error ';
                        self.hasError = true;
                        self.optionsDebug.debug = options.debug;
                        self.optionsDebug.debugText = options.debugText;
                        console.log(error);
                      },
                    );
                  }
                } else {
                  //1
                  if (!options || !options.techOrder || !options.techOrder.length) {
                    console.log('options error');
                    self.hasError = true;
                    self.optionsDebug.debug = options.debug;
                    self.optionsDebug.debugText = options.debugText;
                  } else {
                    self.options = options;
                  }
                }
              }

            },
            function (response) {
              console.log(response);
              if (response.response.status === 500 || response.response.status === 403) {
                self.hasErrorAccess = true;
              }
            },
          );
        } else if (videoFileName !== undefined && videoFileName !== '') {
            /*todo bitrate*/
            let parts = videoFileName.split('-')
            let token_bt= '';
            let uid = videoFileName;
            if(parts.length > 0){
                token_bt= parts.pop()
            }

            let src=`//${process.env.AKAMAI}/i${process.env.DIR_AKAMAI}smil/${uid}.smil/master.m3u8`;
            let arrayBt=[
                {name:'x', value:8000},{name:'y', value:4000},
                {name:'z', value:1500},{name:'t', value:850},
                {name:'k', value:450}, {name:'u', value:250}
                ];
            let newArrayBt=[];
            let  listBt='';
                 arrayBt.forEach(bt=>{
                     if(token_bt.indexOf(bt.name) > -1){
                         newArrayBt.push(bt.value)
                     }
                 })
            if(newArrayBt && newArrayBt.length > 0 && newArrayBt.length === token_bt.length){
                listBt=  ","+ newArrayBt.join()+",";
                uid =  parts.join('-');
                src= `//${process.env.AKAMAI}/i/${process.env.DIR_AKAMAI}mp4/${uid}_${listBt}.mp4.csmil/master.m3u8`
            }
            if(process.env.API_SECURE_URL){
                src= await self.generateToken(src)
                console.log("generateToken",src);
            }
            if(process.env.CLOUD_FLARE){
                src=`//${process.env.CLOUD_FLARE}/${uid}/manifest/video.m3u8`
            }
            options = {
            "uid": uid,
            "playerOptions": {
              "uid": uid,
              "playbackRates": [0.25, 0.5, 1, 1.5, 2],
              "autoplay": false,
              "height": "500",
              "controls": true,
              "techOrder": ["hlsjs", "html5", "flash"],
              "sourceOrder": true,
              "flash": {"hls": {"withCredentials": false}},
              "html5": {"hls": {"withCredentials": false}},
              "sources": [{
                "withCredentials": false,
                "type": "application\/x-mpegURL",
                "src": src,
                "selected": true
              }],
              "textTracks": [],
              "poster": `//${process.env.FO_CLIENT}/web/data/vignettes/${uid}.jpg`,
              "controlBarOptions": true,
              "fullScreen": false
            }
          }
          language = language ? language : (options.infoOptions && options.infoOptions.current_lang ? options.infoOptions.current_lang : 'fr');
          let lan = language || 'fr';
          options = self.getOptions(
            options,
            plugin,
            skin,
            menu,
            autoplay,
            loop,
            controlBar,
            crypttext,
            self,
            lan,
          );
          this.options = options;

          HTTP.get(Routing.generate("api_media_get_decrypted_infos", {uid: uid})).then(function (response) {


            let newOptions = response.data.data;
            options.textTracks= newOptions.playerOptions.textTracks;
            self.videoId= newOptions.playerOptions.videoId;

            delete newOptions.playerOptions

            let optionsAssign = Object.assign({}, options, newOptions)

            language = language ? language : (options.infoOptions && options.infoOptions.current_lang ? options.infoOptions.current_lang : 'fr');
            let lan = language || 'fr';
            options = self.getOptions(
              optionsAssign,
              plugin,
              skin,
              menu,
              autoplay,
              loop,
              controlBar,
              crypttext,
              self,
              lan,
            );

            self.options = options;
            if(options.textTracks.length > 0){
                eventHub.$emit('displayCC',{textTracks: options.textTracks, value: true})
            }

          }, function (response) {
            console.log('api error');
            self.hasError = true;
          });


        } else {
          self.hasError = true;
        }

      },
    },
    watch: {
      url(value, oldValue) {
        if (value !== oldValue && value !== '' && value !== undefined) {
          this.comments = false;
            this.createPlayer()
        } else if (value === '' || value === undefined) {
          try {
            videojs.getAllPlayers()[0].pause();
          } catch (e) {
          }
        }
      },
      query: {
        handler(val, oldVal) {
          if (val !== oldVal) {
              this.createPlayer()
          }

        },
        deep: true,
      },
    },
    $getInfoOptions: function () {
      if (this.options && this.options.infoOptions) {
        return this.options.infoOptions;
      } else return null;
    },
    created: function () {
      var self = this;
      eventHub.$on('readyPlayer', this.readyPlayer);
      eventHub.$on('infoDetails', this.infoDetails);
      eventHub.$on('partageButton', this.partageButton);
      eventHub.$on('nextVideo', this.nextVideo);
      eventHub.$on('playerError', function (event) {
        console.log(event)
        /*CODE 4*/

        if(event.code == "error-3"){

          try{
            self.$i18n.locale = localStorage.getItem('lang-player')? localStorage.getItem('lang-player') : 'fr';
            self.$root.$i18n.locale = this.$i18n.locale;
          }catch(e){
            console.log("exception",e)
          }

          self.hasErrorVideo = true;
          self.formEmail = false;

          self.title = '';
          self.code= event.code;
          self.msg = self.$t('editor.error.no-result-video');

          self.hasError = true;
        }

      });
      try {
        this.$i18n.locale = localStorage.getItem('lang-player')? localStorage.getItem('lang-player') : 'fr';
        this.$root.$i18n.locale = this.$i18n.locale;
      } catch (e) {
        console.log("exception", e)
      }

    },
  };
</script>
<style lang="scss">
  @import '../assets/scss/player.scss';

  .video-js,
  .video-js .vjs-poster {
    background-color: transparent !important;
  }

  .component {
    height: 100%;

    .uep_player {
      height: 100%;
      outline: none;

      * {
        outline: none;
      }

      .video-player {
        height: 100%;

        .video-js {
          height: 100%;
          background: transparent;
        }
      }
    }

    .vjs-tech-flash {
      .video-js {
        .vjs-poster {
          display: none;
        }

        &.skin-default {
          .vjs-poster {
            display: none;

            &.vjs-poster-show {
              display: inline-block;
            }
          }

          &.vjs-has-started {
            .vjs-poster {
              display: none;
            }
          }
        }
      }
    }

    &.comments-list {
      display: flex;

      .uep_player {
        width: 80%;
      }
    }

    .vjs-audio-options-poster {
      .vjs-poster {
        display: block !important;
        z-index: 0;
      }

      .vjs-control-bar {
        z-index: 31;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .component {
      &.comments-list {
        display: block;

        .uep_player {
          width: 100%;
          height: 60%;
        }
      }
    }
  }

  @media only screen and (max-width: 576px) {
    .component {
      &.comments-list {
        .uep_player {
          height: 50%;
        }
      }
    }
  }

  .vjs-control-bar {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .vjs-control-bar-hide .vjs-loading-spinner {
    display: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/UepPlayer.vue